// import { gsap } from "gsap/gsap-core";

/* global gsap: false */

const EFFECT_DURATION = 0.5;
const EFFECT_DISTANCE = 40;

export default class HotelCards {
	constructor() {
		this.cards = document.querySelectorAll(".hotel-card");

		if (0 === this.cards.length) return;

		this.init();

		this.events();
	}

	init() {
		Array.from(this.cards).map((card) => {
			const content = card.querySelector(".content");

			gsap.set(content, {
				y: `${EFFECT_DISTANCE}px`,
			});
		});
	}

	mouseEnterHandler(ev) {
		const card = ev.currentTarget;
		const content = card.querySelector(".content");

		card.classList.add("active");

		gsap.to(content, {
			duration: EFFECT_DURATION,
			y: `-${EFFECT_DISTANCE}px`,
		});

		gsap.to(content.querySelectorAll(".show-on-hover"), {
			duration: EFFECT_DURATION,
			opacity: 1,
		});

		gsap.to(content.querySelector(".logo svg path"), {
			duration: EFFECT_DURATION,
			fill: "var(--theme-color-gold)",
		});
	}

	mouseLeaveHandler(ev) {
		const card = ev.currentTarget;
		const content = card.querySelector(".content");

		card.classList.remove("active");

		gsap.to(content, {
			duration: EFFECT_DURATION,
			y: `${EFFECT_DISTANCE}px`,
		});

		gsap.to(content.querySelectorAll(".show-on-hover"), {
			duration: EFFECT_DURATION,
			opacity: 0,
		});

		gsap.to(content.querySelector(".logo svg path"), {
			duration: EFFECT_DURATION,
			fill: "white",
		});
	}

	events() {
		Array.from(this.cards).map((card) => {
			card.addEventListener("mouseenter", this.mouseEnterHandler.bind(this));
			card.addEventListener("mouseleave", this.mouseLeaveHandler.bind(this));
		});
	}
}
